// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PorterStoreIcons from "./PorterStoreIcons.bs.js";
import * as PorterStoreStrings from "../PorterStoreStrings.bs.js";

function getAnchorPosition(el) {
  var rect = el.getBoundingClientRect();
  return [
          rect.bottom,
          rect.left
        ];
}

function PorterStoreFilterDropdown(Props) {
  var items = Props.items;
  var onToggle = Props.onToggle;
  var onApply = Props.onApply;
  var anchorRef = Props.anchorRef;
  var onClose = Props.onClose;
  var isOpen = Props.isOpen;
  var match = React.useState(function () {
        
      });
  var setPosition = match[1];
  var position = match[0];
  React.useEffect((function () {
          if (isOpen) {
            var el = anchorRef.current;
            if (!(el == null)) {
              var match = getAnchorPosition(el);
              var left = match[1];
              var top = match[0];
              Curry._1(setPosition, (function (param) {
                      return [
                              top,
                              left
                            ];
                    }));
            }
            
          } else {
            Curry._1(setPosition, (function (param) {
                    
                  }));
          }
          
        }), [isOpen]);
  if (!isOpen) {
    return null;
  }
  var dropdownStyle = position !== undefined ? ({
        left: position[1].toString() + "px",
        position: "fixed",
        top: position[0].toString() + "px",
        zIndex: "1001"
      }) : ({
        left: "0",
        position: "fixed",
        top: "0",
        visibility: "hidden"
      });
  return ReactDom.createPortal(React.createElement("div", undefined, React.createElement("div", {
                      className: "ps-filter-dropdown__overlay",
                      onClick: (function (param) {
                          return Curry._1(onClose, undefined);
                        })
                    }), React.createElement("div", {
                      className: "ps-filter-dropdown",
                      style: dropdownStyle
                    }, React.createElement("div", {
                          className: "ps-filter-dropdown__list"
                        }, Belt_Array.map(items, (function (item) {
                                return React.createElement("div", {
                                            key: item.key,
                                            className: "ps-filter-dropdown__row",
                                            onClick: (function (param) {
                                                return Curry._1(onToggle, item.key);
                                              })
                                          }, React.createElement("div", {
                                                className: item.checked ? "ps-filter-checkbox ps-filter-checkbox--checked" : "ps-filter-checkbox"
                                              }, item.checked ? React.createElement(PorterStoreIcons.FilterCheck.make, {}) : null), item.label);
                              }))), React.createElement("div", {
                          className: "ps-filter-dropdown__footer"
                        }, React.createElement("button", {
                              className: "ps-filter-dropdown__apply-btn",
                              onClick: (function (param) {
                                  Curry._1(onApply, undefined);
                                  return Curry._1(onClose, undefined);
                                })
                            }, PorterStoreStrings.applyFilter)))), document.body);
}

var make = PorterStoreFilterDropdown;

export {
  getAnchorPosition ,
  make ,
  
}
/* react Not a pure module */
